import type { AlertProps } from '@mui/material/Alert';
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { forwardRef } from 'react';

export interface SnackBarConfig {
  message?: string;
  open?: boolean;
  type?: 'success' | 'error' | 'warning' | 'info';
}

interface CustomSnackbarProps {
  config?: SnackBarConfig;
  setOpen: (isOpen: boolean) => void;
}

const Alert = forwardRef<HTMLDivElement, AlertProps>(
  (props, ref) => {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  },
);

function CustomSnackbar(props: CustomSnackbarProps) {
  const { config, setOpen } = props;

  const handleClose = (e?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <Snackbar
      open={Boolean(config?.open)}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      sx={{ zIndex: 9999 }}
    >
      <Alert
        onClose={handleClose}
        severity={config?.type ?? 'info'}
        style={{ width: '100%' }}
      >
        {config?.message ?? ''}
      </Alert>
    </Snackbar>
  );
}
export default CustomSnackbar;
